import { createSelector } from 'reselect';
import type { RootState } from 'store/rootReducer';
import { formatTaskDataToFormSubmission } from '#shared/utils/formData';

import {
  createAsyncActionErrorSelector,
  createAsyncActionIsLoadingSelector,
  createAsyncActionValidationErrorsSelector,
} from '../asyncAction';
import {
  ProcessDefinitionsState,
  getGroupedProcessDefinitionsRequest,
  getProcessDefinitionsCountRequest,
  startProcessRequest,
  getProcessDefinitionFormRequest,
  getProcessDefinitionRequest,
  startProcessWithFormRequest,
} from './slice';

export const selectProcessDefinitionsState = (state: RootState): ProcessDefinitionsState => state.processDefinitions;

export const selectProcessDefinitions = createSelector(
  selectProcessDefinitionsState,
  (processDefinitionsState) => processDefinitionsState.list,
);
export const selectGroupedProcessDefinitions = createSelector(
  selectProcessDefinitionsState,
  (processDefinitionsState) => processDefinitionsState.groupData,
);
export const selectProcessDefinitionsCount = createSelector(
  selectProcessDefinitionsState,
  (processDefinitionsState) => processDefinitionsState.count,
);
export const selectProcessDefinitionForm = createSelector(
  selectProcessDefinitionsState,
  (processDefinitionsState) => processDefinitionsState.form,
);

export const selectProcessDefinitionsIsLoading = createSelector(
  createAsyncActionIsLoadingSelector(getGroupedProcessDefinitionsRequest.type),
  createAsyncActionIsLoadingSelector(startProcessRequest.type),
  (getLoading, startLoading) => getLoading || startLoading,
);
export const selectProcessDefinitionsCountIsLoading = (
  createAsyncActionIsLoadingSelector(getProcessDefinitionsCountRequest.type)
);
export const selectProcessDefinitionsCountError = (
  createAsyncActionErrorSelector(getProcessDefinitionsCountRequest.type)
);
export const selectProcessDefinitionsError = (
  createAsyncActionErrorSelector(getGroupedProcessDefinitionsRequest.type)
);
export const selectProcessDefinitionError = (
  createAsyncActionErrorSelector(getProcessDefinitionRequest.type)
);
export const selectProcessDefinitionFormError = (
  createAsyncActionErrorSelector(getProcessDefinitionFormRequest.type)
);

export const selectProcessDefinitionLoading = createSelector(
  createAsyncActionIsLoadingSelector(getProcessDefinitionFormRequest.type),
  createAsyncActionIsLoadingSelector(getProcessDefinitionRequest.type),
  createAsyncActionIsLoadingSelector(startProcessWithFormRequest.type),
  (
    formLoading,
    processDefinitionLoading,
    processWithFormStarting,
  ) => formLoading || processDefinitionLoading || processWithFormStarting,
);

export const selectProcessDefinitionFormValidationErrors = (
  createAsyncActionValidationErrorsSelector(startProcessWithFormRequest.type)
);

export const selectStartFormSubmissionData = createSelector(
  selectProcessDefinitionsState,
  (form) => formatTaskDataToFormSubmission(form.formData?.data),
);
